/* unplugin-vue-components disabled */import { render } from "./LoginView.vue?vue&type=template&id=8f6a2296&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=8f6a2296&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f6a2296"]])

export default __exports__